import ApiStatistics from '@/api/apiStatistics'
import ApiTournaments from '@/api/apiTournaments'
import Vue from 'vue'
import router from '../router'
import { createActionHelpers } from 'vuex-loading'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})

const state = {
  filerYears:[],
  filtersSportPlaces:[],
  filtersTournaments:[],
  filtersStatus:[],
  filteredRegistrations:[]
}

const actions = {
  loadFilterYears(context) {
    //startLoading(context.dispatch, 'loading teams')
    ApiStatistics.years((response) => {
      console.log("loadFilterYears",response)
      context.commit("updateFilerYears", response.data.data)
      //context.commit("updateTeams", teams)
      //endLoading(context.dispatch, 'loading teams')
    }, error => {
      console.log('Error', error)
      //endLoading(context.dispatch, 'loading teams')
    })
  },
  loadFilterSportPlaces(context) {
    //startLoading(context.dispatch, 'loading teams')
    ApiStatistics.sportPlaces((response) => {
      console.log("loadFilterSportPlaces",response)
      context.commit("updateFiltersSportPlaces", response.data.data)
      //endLoading(context.dispatch, 'loading teams')
    }, error => {
      console.log('Error', error)
      //endLoading(context.dispatch, 'loading teams')
    })
  },
  loadFilterTournaments(context) {
    //startLoading(context.dispatch, 'loading teams')
    ApiStatistics.tournaments((response) => {
      console.log("loadFilterTournaments",response)
      context.commit("updateFiltersTournaments", response.data.data)
      //endLoading(context.dispatch, 'loading teams')
    }, error => {
      console.log('Error', error)
      //endLoading(context.dispatch, 'loading teams')
    })
  },
  loadFilterStatus(context) {
    //startLoading(context.dispatch, 'loading teams')
    ApiStatistics.status((response) => {
      console.log("loadFilterStatus",response)
      context.commit("updateFiltersStatus", response.data.data)
      //endLoading(context.dispatch, 'loading teams')
    }, error => {
      console.log('Error', error)
      //endLoading(context.dispatch, 'loading teams')
    })
  },
  loadFilteredRegistrations(context,filters){
    ApiStatistics.registrations(filters,(response) => {
      console.log("loadFilteredRegistrations",response.data.data)
      context.commit("updateFilteredRegistrations", response.data.data)
      //endLoading(context.dispatch, 'loading teams')
    }, error => {
      console.log('Error', error)
      //endLoading(context.dispatch, 'loading teams')
    })
  },
  downloadRegistrationsCSV(context,filters){
    ApiStatistics.registrationsCSV(filters,(response) => {
      console.log("loadFilteredRegistrations",response.data)
      //context.commit("updateFilteredRegistrations", response.data.data)
      //endLoading(context.dispatch, 'loading teams')
    }, error => {
      console.log('Error', error)
      //endLoading(context.dispatch, 'loading teams')
    })
  },
  resolveRegistrationsHasStatisticsAdmin(context,data){
    startLoading(context.dispatch, 'loading data')
    ApiTournaments.resolveRegistrations(data.tournamentId,data.registrationId,data.accepted,data.ammount, response => {
      console.log("createRegistration",response)
      endLoading(context.dispatch, 'loading data')
      if(data.callBack){
        data.callBack()
      }
      //context.dispatch('loadTournamentRegistrations',data.tournamentId)
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'loading data')
    })
  },
  acceptAndMarkAsPaidARegistrationHasStatisticsAdmin(context,data){
    startLoading(context.dispatch, 'loading data')
    ApiTournaments.acceptAndMarkAsPaidARegistration(data.tournamentId,data.registrationId,data.ammount, response => {
      console.log("createRegistration",response)
      endLoading(context.dispatch, 'loading data')
      if(data.callBack){
        data.callBack()
      }
      //context.dispatch('loadTournamentRegistrations',data.tournamentId)
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'loading data')
    })
  },
  archiveRegistrationsHasStatisticsAdmin(context,data){
    startLoading(context.dispatch, 'loading data')
    ApiTournaments.archiveRegistration(data.tournamentId,data.registrationId, response => {
      console.log("createRegistration",response)
      endLoading(context.dispatch, 'loading data')
      if(data.callBack){
        data.callBack()
      }
      //context.dispatch('loadTournamentRegistrations',data.tournamentId)
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'loading data')
    })
  }
}

const mutations = {
  updateFilerYears(state, data){
    console.log("FILTERS",data)
    state.filerYears = data
  },
  updateFiltersTournaments(state, data){
    state.filtersTournaments = data
  },
  updateFiltersStatus(state, data) {
    state.filtersStatus = data
  },
  updateFiltersSportPlaces(state,data){
    state.filtersSportPlaces = data
  },
  updateFilteredRegistrations(state,data){
    console.log("updateFilteredRegistrations",data)
    state.filteredRegistrations = data
  }
}

const getters = {
  currentFilerYears(state) {

    return state.filerYears
  },
  currentFiltersTournaments(state) {
    return state.filtersTournaments
  },
  currentFiltersStatus(state) {
    return state.filtersStatus
  },
  currentFiltersSportPlaces(state){
    console.log("currentFiltersSportPlaces",state.filtersSportPlaces)
    return state.filtersSportPlaces
  },
  currentFilteredRegistrations(state){
    console.log("currentFilteredRegistrations",state.filteredRegistrations)
    return state.filteredRegistrations
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/statistics.js